<template>
  <div v-if="!error && event != null"> 
    <div class="shadow rounded p-element-page bg-white" >
      <h1 class="h1-title">{{  event.title }}</h1>
       <nuxt-link :to="routePath({name:'kalendar-dogadjaja-event-kategorija-year-month-page',params:{event: $srbTolat.srbTolat(event.category_name), 
                                                                                                      year: getYear(), 
                                                                                                      month: getMonth() , 
                                                                                                      page: 1}})">
         <h2 class="h2-subtitle text-info text-uppercase">{{  event.category_name }}</h2>
       </nuxt-link>      
      <hr>
    </div>
    <div class="container-a mt-2 mb-3" v-if="$screen.showMobileAds">
       <AdsEventSingleMobile></AdsEventSingleMobile>
    </div>  
    <BContainer fluid class="container-pages mt-2">
        <BRow>
          <BCol xl="12">
            <div class="shadow rounded p-element-page bg-white"  >
                <i class="esei icon-map-marker place-icon-color-ads"></i> {{ event.place_name }}
            </div> 
            <div class="shadow rounded p-element-page bg-white  mt-2" style="min-height: 110px;">
           <i class="esei ficon-clock-solid place-icon-color-ads"></i> Datum
           <p v-for="date in dateBetween(event.start_date_convert, 
                                         event.end_date_convert)" 
                  :key="date" class="mb-1 p-0">
                  {{ date }}
            </p>
          </div>
          </BCol>
        </BRow>
    </BContainer>
    <div class="shadow rounded p-element-page bg-white mt-2 text-center">
       
          <NuxtImg  
      :src="$getImageSrc(event.img)"
       
       :alt="event.title"
       
       loading="lazy"
      class="rounded img-fluid"></NuxtImg>   
     </div>
     <div class="a-container mt-2 mb-3" v-if="$screen.showMobileAds">
       <AdsEventMobile></AdsEventMobile>
     </div>
     <div class='shadow rounded p-element-page bg-white mt-2 mb-2 ql-editor' 
       v-html="event.description">
    </div> 
    <div class="shadow rounded p-element-page bg-white"  >
     Izvor: <a :href="event.event_url_organizer_event"
                target="_blank">
                {{ event.event_url_organizer_event }}
           </a> 
    </div>   
  
   <FaqCard v-if="faqs?.faq" :faq="faqs.faq" class="mt-2"></FaqCard>

   <div class="container-a mt-2 mb-3" v-if="$screen.isProduction" >
        <AdsEventSingleBottom></AdsEventSingleBottom>
   </div>  
  </div>
</template>

<script setup>
 const dayjs = useDayjs()
 const route = useRoute();
 const routePath = useRoutePath()
import { useEventStore } from "~/stores/events";
const { $srbTolat } = useNuxtApp()
import { BContainer, BRow, BCol } from 'bootstrap-vue-next';
import AdsEventSingleBottom from '~/components/GoogleAdvertisements/AdsEventSingleBottom.vue';
import AdsEventSingleMobile from '~/components/GoogleAdvertisements/AdsEventSingleMobile.vue';
import AdsEventMobile from '~/components/GoogleAdvertisements/AdsEventMobile.vue';
 import { useShareMetaStore } from "~/stores/shareMeta";
import FaqCard from '~/components/widgets/Advertisement/FaqCard.vue';

const shareMeta = useShareMetaStore();
import { buildEventJsonLd } from "~/util/schema/eventSchema";
const useStore = useEventStore();

const config = useRuntimeConfig()
 
const titleParam = computed(() => route.params.title.split('-').join(' '));


  const { data: response, error, pending} = await useAsyncData(
  () => `events-title-${route.fullPath}`, // key
  () =>
    useStore.getByTitle({title: titleParam.value}),
  {
    watch: [
      () => route.fullPath
    ],
  }
);

const event = computed(() => response.value?.data?.event || null)
const faqs = computed(() => response.value?.data?.faqs || null)

  const getYear = () => {

     return dayjs().year().toString()
  }

  const getMonth = () => {

    return dayjs().format('MMMM').toLowerCase()
}

const dateFormatDay = (date) => {

    return  dayjs(date).format('dddd') + " " + dayjs(date).format('DD.MM.YYYY') + '.' 

}
const dateBetween = (start, end) => {

    let dayLabel = [];
    for (var d = new Date(start); d <= new Date(end); d.setDate(d.getDate() + 1)) {
          dayLabel.push(dateFormatDay(d));
      }
     return dayLabel;
  }

const canonicalUrl = computed(() => `https://pijace.com${route.fullPath}`)

const headTitle = computed(() => event.value?.title || 'Kalendar događaja')

const headDescription = computed(() => {
  const ev = event.value
  if (!ev) return 'Kalendar događaja na Pijace.com'
  return ev.description_meta
    || String(ev.description || '').replace(/<[^>]+>/g, '').slice(0, 160)
    || ev.title
})

const ogImage = computed(() => event.value?.img ?? null)

// JSON-LD: Event schema preko util-a
const eventLd = computed(() => {
  const ev = event.value
  if (!ev) return null

  const baseUrl = config.public.API_BASE
  const urlPath = `kalendar-dogadjaja/${$srbTolat.srbTolatPath(ev.category_name)}/${$srbTolat.srbTolatPath(ev.title)}`

  return buildEventJsonLd({ event: ev, baseUrl, urlPath })
})

// JSON-LD: FAQPage — emituje se SAMO kad API vrati FAQ za ovaj događaj.
// Admin može da doda custom FAQ kroz panel; ako ga nema, schema se ne
// generiše (bolje nego template-ovan generički FAQ na svim stranicama).
const faqSchema = computed(() => {
  let faq = faqs?.value?.faq

  if (typeof faq === 'string') {
    try {
      faq = JSON.parse(faq)
    } catch {
      return null
    }
  }

  if (!Array.isArray(faq) || !faq.length) {
    return null
  }

  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faq.map(item => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer
      }
    }))
  }
})

// JSON-LD: BreadcrumbList — Kalendar događaja → kategorija → naslov
const breadcrumbLd = computed(() => {
  const ev = event.value
  if (!ev) return null

  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Kalendar događaja',
        item: 'https://pijace.com/kalendar-dogadjaja'
      },
      ...(ev.category_name
        ? [{
            '@type': 'ListItem',
            position: 2,
            name: ev.category_name,
            item: `https://pijace.com/kalendar-dogadjaja/${$srbTolat.srbTolat(ev.category_name)}/kategorija/${getYear()}/${getMonth()}/1`
          }]
        : []),
      {
        '@type': 'ListItem',
        position: ev.category_name ? 3 : 2,
        name: ev.title,
        item: canonicalUrl.value
      }
    ]
  }
})

watchEffect(() => {
  shareMeta.setMeta({
    title: headTitle.value,
    description: headDescription.value,
    url: canonicalUrl.value,
  })
})

usePijaceSeo({
  title: headTitle,
  description: headDescription,
  url: canonicalUrl,
  type: 'article',
  image: ogImage,
  jsonLd: () => [eventLd.value, breadcrumbLd.value, faqSchema.value],
})
 

</script>

<style>

</style>